import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../Css/Auth.css";

const GoogleIcon = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const Login = () => {
  const { loginWithEmail, loginWithGoogle, resetPassword } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);

  const redirectTo = location.state?.from?.pathname || "/dashboard";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const { error: err } = await loginWithEmail(email, password);
    if (err) {
      setError(err.message);
      setLoading(false);
    } else {
      navigate(redirectTo, { replace: true });
    }
  };

  const handleGoogle = async () => {
    setError("");
    const { error: err } = await loginWithGoogle();
    if (err) setError(err.message);
  };

  const handleForgot = async () => {
    if (!email) {
      setError("Enter your email address above to reset your password.");
      return;
    }
    setError("");
    const { error: err } = await resetPassword(email);
    if (err) {
      setError(err.message);
    } else {
      setResetSent(true);
    }
  };

  return (
    <div className="authPage">
      <div className="authCard">
        <h2>Welcome back</h2>
        <p className="authSubtitle">Log in to your Manognaa Solutions account</p>

        {error && <div className="authError">{error}</div>}
        {resetSent && (
          <div className="authError" style={{ background: "#f0fdf4", borderColor: "#a7f3d0", color: "#065f46" }}>
            Password reset email sent! Check your inbox.
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="authField">
            <label htmlFor="email">Email address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="you@example.com"
            />
          </div>

          <div className="authField">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
            />
          </div>

          <div className="forgotLink">
            <button type="button" onClick={handleForgot}>
              Forgot password?
            </button>
          </div>

          <button type="submit" className="authSubmitBtn" disabled={loading}>
            <span>{loading ? "Logging in..." : "Log in"}</span>
          </button>
        </form>

        <div className="authDivider">or</div>

        <button type="button" className="authGoogleBtn" onClick={handleGoogle}>
          <GoogleIcon />
          Continue with Google
        </button>

        <div className="authFooter">
          Don't have an account?{" "}
          <Link to="/signup">Sign up free</Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
